import ApiCore from '../utilities/Core';

// Login API

const url = 'absenceHolidayRangeList';
const plural = 'absenceHolidayRangeList';
const single = 'absenceHolidayRangeList';

export const apiAbsenceHolidayRangeList = new ApiCore({
    getAll: false,
    getSingle: false,
    post: true,
    put: false,
    patch: false,
    delete: false,
    url: url,
    plural: plural,
    single: single,
});
